import { render, staticRenderFns } from "./forestry.vue?vue&type=template&id=b4cbe2bc&scoped=true&"
import script from "./forestry.vue?vue&type=script&lang=js&"
export * from "./forestry.vue?vue&type=script&lang=js&"
import style0 from "./forestry.vue?vue&type=style&index=0&id=b4cbe2bc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cbe2bc",
  null
  
)

export default component.exports